import { Routes } from '@angular/router'
import { AppLayoutComponent } from './layout/feature/layout/app-layout.component'
import { authGuard } from './core/guards/auth.guard'
import { profilGuard } from './core/guards/profil.guard'
import { NotFoundComponent } from './error-pages/feature/not-found/not-found.component'
import { UserNotAuthenticatedComponent } from './error-pages/feature/user-not-authenticated/user-not-authenticated.component'
import {
  ChantierUnauthorizedComponent
} from './error-pages/feature/chantier-unauthorized/chantier-unauthorized.component'
import { globalResolver } from './core/resolvers/global.resolver'

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        canMatch: [authGuard()],
        canActivate: [profilGuard()],
        resolve: { data: globalResolver() },
        children: [
          { path: '', loadChildren: () => import('./home/feature/home.routes').then((m) => m.HOME_ROUTES) },
          {
            path: 'user-management',
            loadChildren: () =>
              import('./user-management/feature/user-management.routes').then((m) => m.USER_MANAGEMENT_ROUTES),
          },
        ],
      },
      { path: 'user-not-authenticated', component: UserNotAuthenticatedComponent },
      { path: 'not-found', component: NotFoundComponent },
      { path: 'unauthorized-chantier/:codeChantier', component: ChantierUnauthorizedComponent },
      { path: 'unauthorized-chantier', component: ChantierUnauthorizedComponent },
      { path: '**', redirectTo: 'not-found' },
    ],
  },
]
